// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector } from 'reselect';
import { LabInformation } from '../../../types/Model';
import { LabInformationState } from '../../reducers/labInformationReducer';

import { RootState } from '../../rootReducer';

export const LabsRaw = (state: RootState):LabInformationState => state.labInformationReducer;

export const makeLabByIdSelector = (id: number): Selector<RootState, LabInformation> =>
  createSelector(
    LabsRaw,
    (labInformationReducer) => labInformationReducer.labInformation[id] || {} as LabInformation
  );

export const makeIsFetchingLab = (): Selector<RootState, boolean> => {
  return createSelector(
    LabsRaw,
    (labInformationReducer) => labInformationReducer.isLoading
  );
};

export const makeError = (): Selector<RootState, Error | undefined> => {
  return createSelector(
    LabsRaw,
    (labInformationReducer) => labInformationReducer.error
  );
}
